import * as React from "react";

const CalifPropIconNew: React.FC = () => {
    return (
        <svg width="22" height="21" xmlns="http://www.w3.org/2000/svg"> <defs><filter color-interpolation-filters="auto" id="a"><feColorMatrix in="SourceGraphic" values="0 0 0 0 0.000000 0 0 0 0 0.145098 0 0 0 0 0.329412 0 0 0 1.000000 0"></feColorMatrix></filter></defs>  <g transform="translate(0.000000,21.000000) scale(0.100000,-0.100000)"> <path d="M57 111 c-26 -48 -47 -93 -47 -100 0 -7 32 -11 100 -11 68 0 100 4 100 11 0 16 -92 189 -100 189 -4 0 -28 -40 -53 -89z m96 -10 c20 -37 37 -71 37 -75 0 -3 -36 -6 -80 -6 -44 0 -80 3 -80 6 0 11 74 144 80 144 3 0 22 -31 43 -69z"></path> <path d="M100 100 c0 -16 5 -30 10 -30 6 0 10 14 10 30 0 17 -4 30 -10 30 -5 0 -10 -13 -10 -30z"></path> <path d="M100 39 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"></path> </g> </svg>
    );
};


export default React.memo(CalifPropIconNew);
